module.exports = __webpack_public_path__ + "static/media/book-cover-green.5ee10ec2.jpg";